import i18n from 'i18next';

// Translation function
export const translate = (key) => {
  try {
    return i18n.t(key);
  } catch (e) {
    return key;
  }
};